export const Gender = ['male', 'female', 'mix'];
export const Species = ['mouse', 'rat', 'monkey'];
export const Implant = ['subcutaneous', 'intravenous', 'orthotopic', 'none'];
